// material-ui
import { createTheme } from '@mui/material/styles';

// third-party
import { presetDarkPalettes, presetPalettes, PalettesProps } from '@ant-design/colors';

// project import
import ThemeOption from './theme';
import { darkTokens, lightTokens } from './colors';

// types
import { PaletteThemeProps } from 'types/theme';
import { PresetColor, ThemeMode } from 'types/config';

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (mode: ThemeMode, presetColor: PresetColor) => {
  const colors: PalettesProps = mode === ThemeMode.DARK ? presetDarkPalettes : presetPalettes;

  // Warm neutral ramp (COLORS.md · Neutral); dark mode keeps the reversed order the components expect.
  let greyPrimary = [
    '#FFFFFF',
    '#FAF9F6',
    '#F1EEE9',
    '#E4DFD7',
    '#D3CEC6',
    '#B8AEA4',
    '#8C8178',
    '#5A5048',
    '#3A332D',
    '#141210',
    '#000000'
  ];
  let greyAscent = ['#FAF9F6', '#B8AEA4', '#3A332D', '#1F1B18'];
  let greyConstant = ['#FAF9F6', '#E4DFD7'];

  if (mode === ThemeMode.DARK) {
    greyPrimary = ['#000000', '#141210', '#1A1714', '#3A332D', '#5A5048', '#8C8178', '#B8AEA4', '#D3CEC6', '#E4DFD7', '#F1EEE9', '#FAF9F6'];
    greyAscent = ['#FAF9F6', '#B8AEA4', '#3A332D', '#1F1B18'];
    greyConstant = ['#141210', '#3A332D'];
  }
  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor: PaletteThemeProps = ThemeOption(colors, presetColor, mode);
  const tokens = mode === ThemeMode.DARK ? darkTokens : lightTokens;

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff'
      },
      ...paletteColor,
      text: {
        primary: tokens['text-primary'],
        secondary: tokens['text-secondary'],
        disabled: tokens['text-disabled']
      },
      action: {
        disabled: tokens['text-disabled'],
        disabledBackground: tokens['bg-subtle'],
        hover: mode === ThemeMode.DARK ? 'rgba(250,249,246,.06)' : 'rgba(20,18,16,.04)',
        selected: tokens['brand-soft']
      },
      divider: tokens['border-subtle'],
      background: {
        paper: tokens['bg-surface'],
        default: tokens['bg-page']
      }
    }
  });
};

export default Palette;
